// Auto-generated file 

import {MapOfDatasetDefaults} from "./types";

export const DATASET_DEFAULTS: MapOfDatasetDefaults = {
	"bardataaggcrit": {
		"displayName": "Criterion",
		"field": "Scheduled Quantity",
		"layerType": "point",
		"tooltipFields": [
			"Scheduled Forecast",
			"Scheduled Quantity Close",
			"Operating Capacity",
			"Operational Capacity Percent"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"commodity3": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"dailycfsr": {
		"displayName": "CFSR",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dailyclimo": {
		"displayName": "CLIMO",
		"field": "2M Daily Avg Temp official 30yr Climo",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min official 30yr Climo",
			"2M Daily Avg Max official 30yr Climo",
			"Daily Precip official 30yr Climo"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dailycrit": {
		"displayName": "Criterion",
		"field": "Scheduled Quantity",
		"layerType": "point",
		"tooltipFields": [
			"Scheduled Forecast",
			"Scheduled Quantity Close",
			"Operating Capacity",
			"Operational Capacity Percent"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dailycritfinancial": {
		"displayName": "Criterion",
		"field": "Scheduled Quantity",
		"layerType": "point",
		"tooltipFields": [
			"Scheduled Forecast",
			"Scheduled Quantity Close",
			"Operating Capacity",
			"Operational Capacity Percent"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dailyece": {
		"displayName": "ECE",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dailyecex": {
		"displayName": "ECEX",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dailyecm": {
		"displayName": "ECM",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dailygefs": {
		"displayName": "GEFS",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dailygfs": {
		"displayName": "GFS",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dailymetar": {
		"displayName": "METAR",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dailyseas": {
		"displayName": "SEAS",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"daypluscfsr": {
		"displayName": "CFSR",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dayplusclimo": {
		"displayName": "CLIMO",
		"field": "2M Daily Avg Temp official 30yr Climo",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min official 30yr Climo",
			"2M Daily Avg Max official 30yr Climo",
			"Daily Precip official 30yr Climo"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"daypluscrit": {
		"displayName": "Criterion",
		"field": "Scheduled Quantity",
		"layerType": "point",
		"tooltipFields": [
			"Scheduled Forecast",
			"Scheduled Quantity Close",
			"Operating Capacity",
			"Operational Capacity Percent"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"daypluscritfinancial": {
		"displayName": "Criterion",
		"field": "Scheduled Quantity",
		"layerType": "point",
		"tooltipFields": [
			"Scheduled Forecast",
			"Scheduled Quantity Close",
			"Operating Capacity",
			"Operational Capacity Percent"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dayplusece": {
		"displayName": "ECE",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dayplusecex": {
		"displayName": "ECEX",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dayplusecm": {
		"displayName": "ECM",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dayplusgefs": {
		"displayName": "GEFS",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dayplusgfs": {
		"displayName": "GFS",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dayplusiceg": {
		"displayName": "ICEG",
		"field": "Last",
		"layerType": "geojson",
		"tooltipFields": [
			"Country"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dayplusiir": {
		"displayName": "IIR",
		"field": "Capacity Mbcd",
		"layerType": "geojson",
		"tooltipFields": [
			"Operational Capacity",
			"Outage Capacity Mbcd",
			"Outage Type"
		],
		"opacity": 50,
		"shape": "gas_station",
		"pointSize": 30
	},
	"daypluskpig": {
		"displayName": "Kpler Inventories - LNG",
		"field": "Inventory Storage Volume",
		"layerType": "point",
		"tooltipFields": [
			"Inventory Capacity",
			"Net Gas Flow",
			"Heel"
		],
		"opacity": 75,
		"shape": "oil",
		"pointSize": 30
	},
	"daypluskpio": {
		"displayName": "Kpler Inventories Oil",
		"field": "Inventory Level",
		"layerType": "point",
		"tooltipFields": [
			"Inventory Capacity",
			"Inventory Capacity Utilization"
		],
		"opacity": 75,
		"shape": "oil",
		"pointSize": 30
	},
	"daypluskplg": {
		"displayName": "Kpler LNG",
		"field": "Cargo Tons",
		"layerType": "point",
		"tooltipFields": [
			"Vessel",
			"Vessel Type",
			"Capacity",
			"PortCall Grade",
			"Destination"
		],
		"opacity": 75,
		"shape": "vessel",
		"pointSize": 30,
		"directionField": "Heading"
	},
	"daypluskplo": {
		"displayName": "Kpler Liquids",
		"field": "Volume bbl",
		"layerType": "point",
		"tooltipFields": [
			"Vessel",
			"Vessel Type",
			"Capacity",
			"PortCall Grade",
			"Destination"
		],
		"opacity": 75,
		"shape": "vessel",
		"pointSize": 30,
		"directionField": "Heading"
	},
	"daypluskplp": {
		"displayName": "Kpler LPG",
		"field": "Volume bbl",
		"layerType": "point",
		"tooltipFields": [
			"Vessel",
			"Vessel Type",
			"Capacity",
			"PortCall Grade",
			"Destination"
		],
		"opacity": 75,
		"shape": "vessel",
		"pointSize": 30,
		"directionField": "Heading"
	},
	"dayplusmetar": {
		"displayName": "METAR",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"dayplusseas": {
		"displayName": "SEAS",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"histdataaggcrit": {
		"displayName": "Criterion",
		"field": "Scheduled Quantity",
		"layerType": "point",
		"tooltipFields": [
			"Scheduled Forecast",
			"Scheduled Quantity Close",
			"Operating Capacity",
			"Operational Capacity Percent"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"intracrit": {
		"displayName": "Criterion",
		"field": "Scheduled Quantity",
		"layerType": "point",
		"tooltipFields": [
			"Scheduled Forecast",
			"Scheduled Quantity Close",
			"Operating Capacity",
			"Operational Capacity Percent"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"intracritfinancial": {
		"displayName": "Criterion",
		"field": "Scheduled Quantity",
		"layerType": "point",
		"tooltipFields": [
			"Scheduled Forecast",
			"Scheduled Quantity Close",
			"Operating Capacity",
			"Operational Capacity Percent"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"intradailyiceg": {
		"displayName": "ICEG",
		"field": "Last",
		"layerType": "geojson",
		"tooltipFields": [
			"Country"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"intradailyiir": {
		"displayName": "IIR",
		"field": "Capacity Mbcd",
		"layerType": "geojson",
		"tooltipFields": [
			"Operational Capacity",
			"Outage Capacity Mbcd",
			"Outage Type"
		],
		"opacity": 50,
		"shape": "gas_station",
		"pointSize": 30
	},
	"intradaycfsr": {
		"displayName": "CFSR",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"intradayclimo": {
		"displayName": "CLIMO",
		"field": "2M Daily Avg Temp official 30yr Climo",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min official 30yr Climo",
			"2M Daily Avg Max official 30yr Climo",
			"Daily Precip official 30yr Climo"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"intradayece": {
		"displayName": "ECE",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"intradayecex": {
		"displayName": "ECEX",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"intradayecm": {
		"displayName": "ECM",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"intradaygefs": {
		"displayName": "GEFS",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"intradaygfs": {
		"displayName": "GFS",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"intradaymetar": {
		"displayName": "METAR",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"intradayseas": {
		"displayName": "SEAS",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"kpig": {
		"displayName": "Kpler Inventories - LNG",
		"field": "Inventory Storage Volume",
		"layerType": "point",
		"tooltipFields": [
			"Inventory Capacity",
			"Net Gas Flow",
			"Heel"
		],
		"opacity": 75,
		"shape": "oil",
		"pointSize": 30
	},
	"kpio": {
		"displayName": "Kpler Inventories Oil",
		"field": "Inventory Level",
		"layerType": "point",
		"tooltipFields": [
			"Inventory Capacity",
			"Inventory Capacity Utilization"
		],
		"opacity": 75,
		"shape": "oil",
		"pointSize": 30
	},
	"kplg": {
		"displayName": "Kpler LNG",
		"field": "Cargo Tons",
		"layerType": "point",
		"tooltipFields": [
			"Vessel",
			"Vessel Type",
			"Capacity",
			"PortCall Grade",
			"Destination"
		],
		"opacity": 75,
		"shape": "vessel",
		"pointSize": 30,
		"directionField": "Heading"
	},
	"kplo": {
		"displayName": "Kpler Liquids",
		"field": "Volume bbl",
		"layerType": "point",
		"tooltipFields": [
			"Vessel",
			"Vessel Type",
			"Capacity",
			"PortCall Grade",
			"Destination"
		],
		"opacity": 75,
		"shape": "vessel",
		"pointSize": 30,
		"directionField": "Heading"
	},
	"kplc": {
		"displayName": "Kpler Liquids Clean",
		"field": "Volume bbl",
		"layerType": "point",
		"tooltipFields": [
			"Vessel",
			"Vessel Type",
			"Capacity",
			"PortCall Grade",
			"Destination"
		],
		"opacity": 75,
		"shape": "vessel",
		"pointSize": 30,
		"directionField": "Heading"
	},
	"kpld": {
		"displayName": "Kpler Liquids Dirty",
		"field": "Volume bbl",
		"layerType": "point",
		"tooltipFields": [
			"Vessel",
			"Vessel Type",
			"Capacity",
			"PortCall Grade",
			"Destination"
		],
		"opacity": 75,
		"shape": "vessel",
		"pointSize": 30,
		"directionField": "Heading"
	},
	"kplp": {
		"displayName": "Kpler LPG",
		"field": "Volume bbl",
		"layerType": "point",
		"tooltipFields": [
			"Vessel",
			"Vessel Type",
			"Capacity",
			"PortCall Grade",
			"Destination"
		],
		"opacity": 75,
		"shape": "vessel",
		"pointSize": 30,
		"directionField": "Heading"
	},
	"ngh_tariffs": {
		"displayName": "Nat Gas Hub",
		"field": "Scheduled Quantity",
		"layerType": "point",
		"tooltipFields": [
			"Operating Capacity",
			"Operational Capacity Percent"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"platts": {
		"displayName": "Platts Global Refineries",
		"field": "Operational Capacity",
		"layerType": "point",
		"tooltipFields": [
			"Capacity Mbcd",
			"Outage Capacity Mbcd",
			"Yield Total"
		],
		"opacity": 10,
		"shape": "circle",
		"pointSize": 25
	},
	"platts_pfrm": {
		"displayName": "Platts Global Refineries",
		"field": "Operational Capacity",
		"layerType": "point",
		"tooltipFields": [
			"Capacity Mbcd",
			"Outage Capacity Mbcd",
			"Yield Total",
			"Operational Capacity"
		],
		"opacity": 50,
		"shape": "gas_station",
		"pointSize": 30
	},
	"reli_us_march_projections_animalfood_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"reli_us_march_projections_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"tickcfsr": {
		"displayName": "CFSR",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"tickclimo": {
		"displayName": "CLIMO",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"tickece": {
		"displayName": "ECE",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"tickecex": {
		"displayName": "ECEX",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"tickecm": {
		"displayName": "ECM",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"tickgefs": {
		"displayName": "GEFS",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"tickgfs": {
		"displayName": "GFS",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"tickmetar": {
		"displayName": "METAR",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"tickseas": {
		"displayName": "SEAS",
		"field": "2M Daily Avg Temp",
		"layerType": "point",
		"tooltipFields": [
			"2M Daily Avg Min",
			"2M Daily Avg Max",
			"Daily Precipitation"
		],
		"opacity": 50,
		"shape": "circle",
		"pointSize": 30
	},
	"us_cotton_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_egg_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_feed_corn_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_feed_grain_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_longgrain_rice_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_meats_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_med_shortgrain_rice_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_milk_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_q_animal_product_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_q_prices_animal_product_dairy_prices_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_rice_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_sorghum_barley_oats_ricet_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_soybeans_meal_product_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_soybeans_oil_product_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_soybeans_product_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_sugar_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_wheat_class_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"us_wheat_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"w_cotton_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"w_soybean_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"w_wheat_coarsegrain_corn_rice_snu_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	},
	"wnus_snu_grains_cotton_oilseeds_wasd": {
		"displayName": "Location data not addded yet - ticket is in to add"
	}
};